import { connect } from 'react-redux';
var AdminOptions = function AdminOptions(_ref) {
  var isAdmin = _ref.isAdmin,
    children = _ref.children;
  return isAdmin ? children : null;
};
var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
  var application = _ref2.application,
    user = _ref2.user;
  var _ref3$allowImpersonat = _ref3.allowImpersonation,
    allowImpersonation = _ref3$allowImpersonat === void 0 ? true : _ref3$allowImpersonat;
  return {
    isAdmin: allowImpersonation ? application.enableAdminOptions || user && user.impersonatorIdentity : application.enableAdminOptions
  };
};
export default connect(mapStateToProps)(AdminOptions);